<template>
  <label class="base-radio"
         :class="classes"
         @click="toggleCheck">
    <input ref="input"
           type="radio"
           :checked="checked"
           :disabled="disabled"
           :value="trueValue"
           @blur="onBlur"
           @click="onChange"
           @focus="onFocus"/>

    <div class="checkmark"></div>

    <div class="title" v-if="label || $slots.default">
      <slot>{{ label }}</slot>
    </div>
  </label>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: false
      },

      value: {
        type: [Number, String],
        required: true
      },

      trueValue: {
        type: [Number, String],
        required: true
      },

      checked: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      labelLeft: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isActive: false
      }
    },

    computed: {
      classes() {
        return [
          { 'is-active': this.isActive },
          { 'is-checked': this.isChecked },
          { 'is-disabled': this.disabled },
          { 'label-left': this.labelLeft }
        ]
      },

      isChecked() {
        return (String(this.value).length > 0) && (this.value == this.trueValue)
      }
    },

    created() {
      if (!this.checked) {
        return
      }

      this.$emit('input', this.trueValue)
    },

    methods: {
      focus() {
        this.$refs.input.focus()
      },

      toggleCheck() {
        if (this.disabled) {
          return
        }

        this.$emit('input', this.trueValue)
      },

      onFocus(e) {
        this.isActive = true
        this.$emit('focus', e)
      },

      onBlur(e) {
        this.isActive = false
        this.$emit('blur', e)
      },

      onChange() {
        if (this.trueValue === this.value) {
          return
        }

        this.$emit('change', this.trueValue, this.isChecked)
      }
    }
  };
</script>

<style lang="scss" scoped>
  .base-radio {
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;

    & input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }

    .title {
      margin-left: 10px;
      font-size: 16px;
      color: #3e3a3b;
      user-select: none;
    }

    $checkmark-size: 24px;

    .checkmark {
      position: relative;
      width: $checkmark-size;
      height: $checkmark-size;
      flex-shrink: 0;
      background: transparent;
      border: 2px solid #999;
      border-radius: 50%;
      transition: all .1s ease-out;
    }

    .checkmark::after {
      content: '';
      position: absolute;
      top: 45%;
      left: 60%;
      display: block;
      width: 20%;
      height: 70%;
      transform: translate(-40%, -65%) rotate(45deg);
      border: solid #3e3a3b;
      border-width: 0 calc($checkmark-size / 10) calc($checkmark-size / 10) 0;
      opacity: 0;
      transition: all .1s ease-out;
    }

    &.is-checked {
      .checkmark {
        background: color.adjust(map.get($colors, secondary), $lightness: -8%);
        border-color: transparent;

        &::after {
          opacity: 1;
        }
      }
    }

    &:not(.is-disabled):not(.is-checked):hover,
    &:not(.is-disabled):not(.is-checked).is-active {
      .checkmark {
        background: transparent;
      }

      .checkmark::after {
        border-color: #999;
        opacity: .3;
      }
    }

    &.is-disabled {
      cursor: default;

      .checkmark {
        pointer-events: none;
        background: #e6e6e6;
        opacity: .6;
      }

      .checkmark::after {
        border-color: #7b7b7b;
      }
    }

    &.label-left {
      flex-direction: row-reverse;
      justify-content: space-between;

      .title {
        margin: 0 10px 0 0;
      }
    }
  }
</style>
